export function format (text: string, tokens: any): string {
    let args = arguments;
    if (args.length === 2 && typeof tokens === 'object') {
        return text.replace(/\{([^\}]+)\}/g, function(match: string, varName: string) {
            return typeof tokens[varName] !== 'undefined'
                ? tokens[varName]
                : match
                ;
        });
    } else {
        return text.replace(/\{(\d+)\}/g, function (match: string, number: number) {
            return typeof args[number + 1] !== 'undefined'
                ? args[number + 1]
                : match
                ;
        });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/string.ts
 **/